import { render, staticRenderFns } from "./ProspectCompetition.vue?vue&type=template&id=1a12de04&scoped=true&"
import script from "./ProspectCompetition.vue?vue&type=script&lang=js&"
export * from "./ProspectCompetition.vue?vue&type=script&lang=js&"
import style0 from "./ProspectCompetition.vue?vue&type=style&index=0&id=1a12de04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12de04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSelect,VTextarea})
